export default __webpack_public_path__ + "static/media/office1-before1.eafda3c7.jpg";